import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { map, filter, scan, catchError, take, concatMap } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ConflictErrorService {
  /**
   * @ignore
   */
  constructor() { }

  /**
   * Conflicts error
   * @param errorCode 
   * @returns message error 
   */
  conflictError(errorCode): string {
    let message = "There is a conflict.";

    let errors = Object.keys(ConflictError).map(key => ConflictError[key]);

    if (errors.some(e => e[0] === errorCode)) {
      let err = errors.find(e => e[0] === errorCode);
      message = err[1];
    }

    return message;
  }

}

/**
 * @ignore
 */
export const ConflictError = {
  ERROR_CONFLICT: {},
  ERROR_CONFLICT_DUPLICATE_BACKGROUND: {},
  ERROR_CONFLICT_COLLAGE_PRESET_DUPLICATE_ASSIGNMENT: {},
  ERROR_CONFLICT_PRESET_TARGET_DUPLICATE_POSITION: {},
  ERROR_CONFLICT_DUPLICATE_VEHICLE_DETAILS: {},
  ERROR_CONFLICT_DUPLICATE_USER: {},
  ERROR_CONFLICT_DUPLICATE_USER_EMAIL: {}
}


ConflictError.ERROR_CONFLICT = [4090000, 'Forbidden'];
ConflictError.ERROR_CONFLICT_DUPLICATE_BACKGROUND = [4090001, 'Background already exists'];
ConflictError.ERROR_CONFLICT_COLLAGE_PRESET_DUPLICATE_ASSIGNMENT = [
  4090002,
  'Collage is already assigned to the preset',
];
ConflictError.ERROR_CONFLICT_PRESET_TARGET_DUPLICATE_POSITION = [
  4090003,
  'Position :position is already assigned to the preset with id :presetId',
];
ConflictError.ERROR_CONFLICT_DUPLICATE_VEHICLE_DETAILS = [4090005, 'Vehicle details already exists'];
ConflictError.ERROR_CONFLICT_DUPLICATE_USER = [4090006, 'User already exists'];
ConflictError.ERROR_CONFLICT_DUPLICATE_USER_EMAIL = [4090007, 'User already exists'];
ConflictError.ERROR_CONFLICT_DUPLICATE_USER_EMAIL = [4090011, 'SSH key with that name already exists for the client'];
